import { ConfirmDialogOptions } from './confirmation-dialog-options';
import { CONFIRM_DELETE } from '../constants/dashboard-constants';

export function getDeleteDashboardDialogOptions(isShared: boolean): ConfirmDialogOptions {
    const message = isShared ? `This dashboard is shared. ${CONFIRM_DELETE}` : CONFIRM_DELETE;
    const confirmButtonText = 'Delete';
    const denyButtonText = 'Cancel';
    return { message, confirmButtonText, denyButtonText };
}
